import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { Title, TitleUpsert } from '../../_objects/title';
import { ApiService } from '../base/api-base.service';
import { TitleContractService } from '../interfaces/title-contract.service';
import { NetworkStatusService } from '../network-status.service';
import { TitleOfflineService } from '../offline/title-offline.service';
import { TitleOnlineService } from '../online/title-online.service';

@Injectable()
export class TitleService extends ApiService<TitleContractService> implements TitleContractService {

  constructor(
    protected networkStatusService: NetworkStatusService,
    protected offlineService: TitleOfflineService,
    protected onlineService: TitleOnlineService) {
    super(networkStatusService, offlineService, onlineService);
  }

  // TL01 /api/v1/titles
  getTitles(): Observable<Title> {
    return this.service.getTitles();
  }

  // TL02 /api/tenant/v1/{tenantId}/titles
  upsertTitle(titleUpsert: TitleUpsert): Observable<Title> {
    return this.service.upsertTitle(titleUpsert);
  }
}
